import actions from "./actions";

const initState = {
  areas: [],
  areasTurnOver: [],
  loading: false,
  areaTurnOver: [],
  modalLoading: false,
};

export default function areasReducer(state = initState, { type, ...action }) {
  switch (type) {
    case actions.GET_AREAS_SUCCESS:
      return {
        ...state,
        areas: action.areas,
      };

    case actions.FILTER_BY_AREAS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case actions.FILTER_BY_AREAS_SUCCESS:
      return {
        ...state,
        areasTurnOver: action.areasTurnOver,
        loading: false,
      };

    case actions.FILTER_FOR_ONE_AREA_REQUEST:
      return {
        ...state,
        modalLoading: true,
      };

    case actions.FILTER_FOR_ONE_AREA_SUCCESS:
      return {
        ...state,
        areaTurnOver: action.areaTurnOver,
        modalLoading: false,
      };

    default:
      return state;
  }
}
